<template>
  <div class="case-studies">
    <div class="qbcgBgDiv">
    <img src="../../../assets/qyhztj.png" class="qbcgBg"/>
    </div>  

    <div class="yzcgDiv">
      <div v-if="newsList.length>0">
        <div class="caseStudiesDiv" v-for="(item,index) in newsList" :key="item.id"   @click="openDetail(item)">
          <div class="coverText"><span>{{item.title}}</span></div>
          <div class="caseHtml" v-html="stripImages(item.profile)"></div>
        </div>
      </div>
    <!-- <div class="coverVBox" v-if="newsList.length>0">
    <div class="coverDiv" v-for="(item,index) in newsList" :key="item.id"  :class="getBgClass(index)" @click="openDetail(item)">
    <img :src="item.imgs_src" class="coverImg"/>
    <div class="coverText"><span>{{item.title}}</span></div>
    </div>
    
    </div> -->
              <div style="display: flex;justify-content: center;margin-top: 40px;" v-else>
    <img src="../../../assets/empit.png" class="empitImg" />
    </div>
    </div> 
            <div class="pageBox" v-if="newsList.length>0">
        <el-pagination @size-change="sizePagination" :page-sizes="[2, 4, 10, 20]" @current-change="currentPagination" :page-size="form.pageSize"
          background layout="prev, pager, next,sizes" :total="projectTotal">
        </el-pagination>
      </div>
  </div>
</template>

<script>
export default {
  name: "CaseStudies",
  props: {
    
  },
  data(){
    return{
      projectTotal:0,
      newsList:[],
      form: {
        currPage: 1,
        pageSize: 2,
        identify:5
      },
    }
  },
  mounted(){
    this.getTableList();
  },
  methods: {
    stripImages(html) {
      if (!html) return '';
      return html.replace(/<img[^>]*>/gi, '');
    },
    openDetail(item){
      this.$router.push({
        path: '/CoverDetail',
        query: {
        newsId: item.id,
        id:this.$route.query.id,
        active:4
        }
      });
    },
        sizePagination(e) {
      this.form.pageSize = e;
      this.getTableList();
    },
    currentPagination(e) {
      this.form.currPage = e;
      this.getTableList();
    },
    //     getBgClass(index) {
    //   const pos = index % 3;
    //   if (pos === 1) return 'bg2';
    // },
    getTableList(){
      this.$API.getNewsList(this.form).then(res => {
        this.newsList = res.data.list;
        this.projectTotal = res.data.pageInfo.allRows
        console.log(res);
      });
    },

  }
};
</script>

<style scoped>
.caseStudiesDiv{
  background-image: url('../../../assets/hdjjContentBg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 30px;
  max-height: 200px;
  overflow: hidden;
  padding: 22px 20px;
}
.caseHtml{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
.coverText{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
  text-align: center;
}
.empitImg{
  width: 200px;
  height: 200px;
}
.pageBox {
  width: 100%;
  display: flex;
  justify-content: end;
  cursor: pointer;
  margin-bottom: 30px;
}
.bg2{
  margin: 0 20px;
}
.coverVBox{
  display: flex;
  flex-wrap: wrap;
}
.coverDiv{
  position: relative;
  margin-bottom: 20px;
}

.coverImg{
  width: 386px;
  height: 210px;
}
.yzcgDiv{
  border-radius: 4px;
  margin-bottom: 30px;
}
.qbcgBgDiv{
  display: flex;
  justify-content: center;
}
.qbcgBg{
  width: 462px;
  height: 72px;
  margin-top: 50px;
  margin-bottom: 30px;
}
</style>
